import React from 'react';
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  withStyles,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { StyledPage } from '../../../../../components/StyledPage';
import styledBody from '../../../../../components/StyledBody';
import FormSectionDescription from '../../../../../components/FormSectionDescription';
import ExpansionPanelStyles from '../../../../../components/ExpansionPanelStyles';
import TabHeader from '../../../../../components/TabHeader';
import CopyToClipboardField from '../../../../../components/CopyToClipboardField';

const Body = styledBody();

const styles = {
  ...ExpansionPanelStyles.compressed,
  wrapper: {
    width: '100%',
    borderRadius: '3px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
    backgroundColor: 'white',
  },
  fieldWrapper:{
    width: '50%',
    '&& > div:not(:last-child)': {
      marginRight: '24px',
    }
  }
}

const Installation = ({classes, solution}) => {
  const { kongClientId, kongClientSecret, originId } = solution;
  return (
    <StyledPage>
      <TabHeader
        title="Download and implement the Mobile Consent SDK"
      />
        <Body >
          <div className={classes.wrapper}>
            <ExpansionPanel elevation={2} defaultExpanded className={classes.panel}>
              <ExpansionPanelSummary className={classes.panelSummary} expandIcon={<ExpandMoreIcon/>}>
                <FormSectionDescription title="Mobile Consent Solution ID" description="Click below to copy it."/>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.extendedDetails}>
                <div className={classes.fieldWrapper}>
                  <CopyToClipboardField name="Solution ID" value={originId}/>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel elevation={2} defaultExpanded className={classes.panel}>
              <ExpansionPanelSummary className={classes.panelSummary} expandIcon={<ExpandMoreIcon/>}>
                <FormSectionDescription title="API Authentication Keys" description="In order to use the plugins, you will need to provide two parameters: Client_ID and Client secret. Click below to copy them."/>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.extendedDetails}>
                <div className={classes.fieldWrapper}>
                  <CopyToClipboardField name="Client_ID" value={kongClientId}/>
                  <CopyToClipboardField name="Client secret" value={kongClientSecret}/>
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel elevation={2} className={classes.panel}>
              <ExpansionPanelSummary className={classes.panelSummary} expandIcon={<ExpandMoreIcon/>}>
                <FormSectionDescription title="How to guide" />
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.extendedDetails}>
                <Typography variant="body2">To check how to implement Mobile Consent Solution, go to <a href="https://support.cookieinformation.com/en/collections/3119127-mobile-consent-solution" target="_blank">How to guide</a></Typography>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        </Body>
    </StyledPage>
  )};

export default withStyles(styles)(Installation);
